/**
 * 证书查询（与 web/src/api/cert.js 一致）
 * 参数: sn（证书编号/关键词）
 */
import { fetchWithAuth } from '../utils/request.js';
import { getApiUrl } from '../config/api.js';

export async function queryCertificate(sn) {
  const base = getApiUrl('cert');
  const url = `${base}${base.includes('?') ? '&' : '?'}sn=${encodeURIComponent(sn)}`;
  const res = await fetchWithAuth(url);
  const json = await res.json();
  const codeOk =
    json.code === 200 || json.code === '200' || Number(json.code) === 200;
  if (codeOk && json.data) {
    return { success: true, data: json.data };
  }
  return {
    success: false,
    message: json.message || '查询失败，请检查证书关键词是否正确'
  };
}
